import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'newsletter_subscribers',
            name: 'newsletterSubscriber',
            class: 'Modules\\NewsletterSubscriber\\Entities\\NewsletterSubscriber',

            dataTable: {
                headerTopComponents: [
                    {
                        component: 'export-component',
                        bind: {
                            href: route('pages.admin.site.newletterSubscribers.export'),
				            text: "Exportar Subscriptores"
                        },
                        html: null,
                        on: {}
                    }
                ],
                headerBottomComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ]
            }
        }
    }
}